import { Link } from 'react-router-dom';
import { useTilt, v3 } from '@/hooks/useTilt';
import { PRICES, shekel } from '@/data/prices';

const RepairShowcase = () => {
  const card = useTilt<HTMLDivElement>(4);
  const photo = v3('repair-hands');
  return (
    <section id="repair" className="font-heebo cin-wash-blue py-[clamp(64px,8vw,120px)] px-[clamp(20px,5vw,80px)]">
      <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 cin-reveal">
          <div className="cin-label-ed mb-6">שירות</div>
          <h2 className="cin-display-sm mb-8 text-[var(--cin-ink)]">
            תיקון מחשבים.
            <br />
            <span className="cin-text-gradient-blue">מחיר בכתב, לפני שמתחילים.</span>
          </h2>
          <p className="text-lg text-[var(--cin-muted)] leading-relaxed max-w-xl mb-10">
            מביאים את המחשב לבדיקה במעבדה בנטור ({shekel(PRICES.labCheck.min)}), מקבלים מחיר סופי בכתב, ורק אחרי שאישרתם מתחילים. אם התיקון לא משתלם, תשמעו את זה מראש.
          </p>
          <Link to="/repair-status" className="cin-btn-ghost">
            המחשב כבר אצלנו? לבדיקת סטטוס ←
          </Link>
        </div>
        <div className="lg:col-span-5 cin-reveal cin-reveal-d2">
          <div ref={card} className="relative bg-white border border-[var(--cin-line)] rounded-3xl overflow-hidden cin-tilt">
            {/* Nano Banana photo (2026-10-10) — illustrative close-up, no face. */}
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={photo.src}
                srcSet={photo.srcSet}
                sizes="(min-width: 1024px) 480px, 100vw"
                alt="ידיים של טכנאי מתקנות לוח אם של מחשב נייד עם פינצטה ומברג עדין"
                width={800}
                height={500}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
              />
              <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-white to-transparent" />
            </div>
            <div className="relative z-10 px-8 pb-8 pt-2 md:px-10 md:pb-10 flex flex-col gap-6">
              <div className="cin-label-ed">רוב התיקונים</div>
              <div>
                <div className="text-7xl font-black tracking-tight cin-counter">
                  1–3<span className="text-3xl text-[var(--cin-muted)] font-medium"> ימים</span>
                </div>
                <div className="text-[var(--cin-muted)] mt-2">מהקבלה ועד ההחזרה. כשצריך להזמין חלק, עד שבוע.</div>
              </div>
              <div className="grid grid-cols-3 gap-4 text-center pt-6 border-t border-[var(--cin-line)]">
                <div>
                  <div className="text-2xl font-bold cin-counter">בכתב</div>
                  <div className="text-xs text-[var(--cin-muted)] mt-1">מחיר לפני העבודה</div>
                </div>
                <div>
                  <div className="text-2xl font-bold">{shekel(PRICES.labCheck.min)}</div>
                  <div className="text-xs text-[var(--cin-muted)] mt-1">בדיקה במעבדה</div>
                </div>
                <div>
                  <div className="text-2xl font-bold cin-counter" data-cin-count="3">3</div>
                  <div className="text-xs text-[var(--cin-muted)] mt-1">חודשי אחריות</div>
                </div>
              </div>
            </div>
            <span data-tilt-glare aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-[inherit] opacity-0 transition-opacity duration-300" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RepairShowcase;
